import { InputField } from '@advanza/input'
import { Divider } from '@advanza/ui'
import Button from '@advanza/ui/Button'
import NiceModal, { useModal } from '@ebay/nice-modal-react'
import BaseModal, {
    BaseModalFooter,
    BaseModalHeader,
    BaseModalMainContent,
} from '@trustoo/components/modal/BaseModal'
import { useState } from 'react'

interface ActivateSubscriptionModalProps {
    onConfirm: (overrideAmount: number | null) => void
    onCancel: () => void
}

const ActivateSubscriptionModal = NiceModal.create(
    ({ onConfirm, onCancel }: ActivateSubscriptionModalProps) => {
        const modal = useModal()
        const [overrideAmount, setOverrideAmount] = useState<string>('')

        const onClose = () => {
            modal.resolve()
            modal.hide()
            onCancel()
        }

        return (
            <BaseModal onClose={onClose}>
                <BaseModalHeader>
                    <h2 className="text-display-xs font-bold">Activate Subscription</h2>
                </BaseModalHeader>
                <BaseModalMainContent>
                    <div className="p-2">
                        <p className="mb-4 font-bold">
                            The subscription will be activated with today's date as the start date (
                            {new Date().toLocaleDateString('en-GB')}).
                        </p>
                        <p className="mb-4">
                            Enter a custom subscription fee below. This fixed amount will stay the
                            same for the provider as long as the subscription is active, and won't
                            be affected by any future changes to the standard subscription fee.
                        </p>
                        <Divider s />
                        <div className="mb-4">
                            <InputField
                                type="number"
                                step="0.01"
                                value={overrideAmount}
                                onChange={(e) => setOverrideAmount(e.target.value)}
                                placeholder="Override Amount (optional)"
                            />
                        </div>
                    </div>
                </BaseModalMainContent>
                <BaseModalFooter>
                    <div className="row justify-end gap-2 pr-2">
                        <Button appearance="outlined_primary" onClick={onClose}>
                            Cancel
                        </Button>
                        <Button
                            appearance="primary"
                            onClick={() => {
                                onConfirm(overrideAmount ? parseFloat(overrideAmount) : null)
                                modal.resolve()
                                modal.hide()
                            }}>
                            Activate
                        </Button>
                    </div>
                </BaseModalFooter>
            </BaseModal>
        )
    },
)

export default ActivateSubscriptionModal
